import request from '@/utils/request'
//添加类条目
export function cmsChannelTreeList(params) {
  return request({
    url: '/admin/cmsChannelTreeList',
    method: 'get',
    params: params
  })
}
export function cmsChannelList(parentId) {
  return request({
    url: `/admin/cmsChannelList/${parentId}`,
    method: 'get'
  })
}

export function getCmsChannelList(params) {
  return request({
    url: '/admin/getCmsChannelList',
    method: 'get',
    params: params
  })
}
